<template>
  <div class="qr-code-management">
    <!-- 搜索和新增区域 -->
    <div class="search-add-bar">
      <el-input
          v-model="searchKeyword"
          placeholder="请输入油站名称/二维码编码搜索"
          style="width: 300px; margin-right: 10px"
          @keyup.enter.native="handleSearch"
      >
        <i class="el-icon-search el-input__icon" slot="prefix"></i>
      </el-input>
      <el-button type="primary" @click="handleSearch">搜索</el-button>
      <el-button type="success" @click="openAddDialog">新增二维码</el-button>
    </div>

    <!-- 加载状态 -->
    <el-skeleton v-if="loading" style="margin-top: 20px" :rows="5" animated></el-skeleton>

    <!-- 二维码列表 -->
    <el-table
        v-else
        :data="filteredQrList"
        border
        stripe
        style="width: 100%; margin-top: 20px"
        @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="qrCode" label="二维码编码" min-width="180" />
      <el-table-column prop="stationId" label="油站ID" min-width="120" />
      <el-table-column prop="thirdPartyStationId" label="三方油站ID" min-width="150" />
      <el-table-column prop="stationName" label="油站名称" min-width="200" />
      <el-table-column prop="createTime" label="创建时间" min-width="180" />
      <el-table-column label="二维码预览" min-width="120">
        <template slot-scope="scope">
          <!-- 二维码加载占位 -->
          <el-skeleton v-if="!scope.row.qrImageUrl" variant="circle" style="width: 80px; height: 80px"></el-skeleton>
          <el-image
              v-else
              :src="scope.row.qrImageUrl"
              style="width: 80px; height: 80px; cursor: pointer"
              @click="previewQrCode(scope.row)"
              fit="contain"
              :error="() => scope.row.qrImageUrl = ''"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="250">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="openEditDialog(scope.row)">编辑</el-button>
          <el-button type="success" size="small" @click="downloadSingleQr(scope.row.qrCode, scope.row.qrImageUrl)" :disabled="!scope.row.qrImageUrl">下载</el-button>
          <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div v-if="!loading && total > 0" class="block" style="margin-top:10px">
      <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 空数据提示 -->
    <div v-if="!loading && total === 0" style="text-align: center; padding: 50px; color: #999">
      <el-empty description="暂无二维码数据"></el-empty>
    </div>

    <!-- 批量操作按钮 -->
    <div style="margin-top: 10px">
      <el-button
          type="primary"
          icon="el-icon-download"
          @click="handleBatchDownload"
          :disabled="selectedRows.length === 0"
      >
        批量下载二维码
      </el-button>
      <el-button
          type="danger"
          icon="el-icon-delete"
          @click="handleBatchDelete"
          :disabled="selectedRows.length === 0"
          style="margin-left: 10px"
      >
        批量删除
      </el-button>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
        :visible.sync="dialogVisible"
        :title="dialogType === 'add' ? '新增油站二维码' : '编辑油站二维码'"
        width="500px"
        @close="resetForm"
    >
      <el-form
          ref="qrFormRef"
          :model="qrForm"
          :rules="qrFormRules"
          label-width="100px"
      >
        <el-form-item label="油站ID" prop="stationId">
          <el-input v-model="qrForm.stationId" placeholder="请输入油站ID" />
        </el-form-item>
        <el-form-item label="三方油站ID" prop="thirdPartyStationId">
          <el-input v-model="qrForm.thirdPartyStationId" placeholder="请输入三方油站ID" />
        </el-form-item>
        <el-form-item label="油站名称" prop="stationName">
          <el-input v-model="qrForm.stationName" placeholder="请输入油站名称" />
        </el-form-item>
        <el-form-item label="二维码编码" prop="qrCode">
          <el-input
              v-model="qrForm.qrCode"
              placeholder="为空则自动生成唯一编码"
              :disabled="dialogType === 'edit'"
          />
          <el-button
              type="text"
              size="small"
              @click="generateQrCode"
              v-if="dialogType === 'add'"
          >
            自动生成编码
          </el-button>
        </el-form-item>
        <el-form-item label="二维码预览">
          <div v-if="qrForm.qrImageUrl" style="padding: 10px">
            <img :src="qrForm.qrImageUrl" style="width: 150px; height: 150px" />
          </div>
          <div v-else style="color: #999">请先填写信息生成二维码</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
            type="primary"
            @click="handleSave"
            :loading="saveLoading"
        >
          保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 二维码预览弹窗 -->
    <el-dialog
        :visible.sync="previewDialogVisible"
        title="二维码预览"
        width="300px"
    >
      <div style="text-align: center; padding: 20px">
        <img :src="previewQrUrl" style="width: 200px; height: 200px" />
        <p style="margin-top: 10px; font-weight: bold">{{ previewStationName }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入二维码生成依赖（需先安装：npm install qrcode --save）
import QRCode from 'qrcode';

export default {
  name: 'QrCodeManagement',
  data() {
    return {
      // 数据
      tableLoadData: [],
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页大小
      total: 0, //总条目数
      loading: true, // 列表加载状态
      // 基础URL（请替换为你的实际业务地址）
      baseQrUrl: 'https://tuanyou.hantiankeji.cn/#/pages/index/home',
      // 接口返回的二维码列表
      qrList: [],
      // 搜索关键词
      searchKeyword: '',
      // 选中的行
      selectedRows: [],
      // 弹窗相关
      dialogVisible: false,
      dialogType: 'add', // add:新增 edit:编辑
      saveLoading: false,
      // 表单相关
      qrForm: {
        id: '',
        qrCode: '',
        stationId: '',
        thirdPartyStationId: '',
        stationName: '',
        qrImageUrl: ''
      },
      // 表单校验规则
      qrFormRules: {
        stationId: [{ required: true, message: '请输入油站ID', trigger: 'blur' }],
        thirdPartyStationId: [{ required: true, message: '请输入三方油站ID', trigger: 'blur' }],
        stationName: [{ required: true, message: '请输入油站名称', trigger: 'blur' }],
        qrCode: [{ required: true, message: '请输入二维码编码', trigger: 'blur' }]
      },
      // 预览弹窗相关
      previewDialogVisible: false,
      previewQrUrl: '',
      previewStationName: ''
    };
  },
  computed: {
    // 过滤后的列表
    filteredQrList() {
      if (!this.searchKeyword) {
        return this.qrList;
      }
      return this.qrList.filter(item => {
        return item.stationName.includes(this.searchKeyword) || item.qrCode.includes(this.searchKeyword);
      });
    }
  },
  mounted() {
    this.DataList();
  },

  methods: {
    // 获取列表数据
    async DataList() {
      try {
        this.loading = true; // 开启加载状态
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        };
        const res = await this.$axios.findShopPayListP(param);
        if (res.code === 200) {
          console.log('-----initQrImages7777777------')
          // 深拷贝数据，确保响应式
          this.qrList =res.data.data;
          this.total = res.data.total;
          // 等待二维码生成完成
          console.log('-----initQrImages------')
          await this.initQrImages();
        } else {
          this.$message.error(res.msg || '获取数据失败');
        }
      } catch (error) {
        console.error('获取列表失败：', error);
        this.$message.error('获取数据失败，请重试');
      } finally {
        this.loading = false; // 关闭加载状态
      }
    },
    // 设置每页条数
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.pageNum = 1; // 重置页码
      this.DataList();
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.pageNum = newPage;
      this.DataList();
    },
    // 搜索（带过滤和重新生成二维码）
    async handleSearch() {
      this.loading = true;
      // 重新请求数据（带搜索参数，根据实际接口调整）
      try {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          pageNum: 1,
          pageSize: this.pageSize,
          keyword: this.searchKeyword // 假设接口支持搜索参数
        };
        const res = await this.$axios.findShopPayListP(param);
        if (res.code === 200) {
          this.qrList = JSON.parse(JSON.stringify(res.data.data));
          this.total = res.data.total;
          await this.initQrImages();
          this.$message.success('搜索完成');
        }
      } catch (error) {
        console.error('搜索失败：', error);
        this.$message.error('搜索失败');
      } finally {
        this.loading = false;
      }
    },
    // 拼接二维码的URL参数
    buildQrUrlParams(qrCode, stationId, thirdPartyStationId) {
      const params = new URLSearchParams({
        qrCode: qrCode,
        stationId: stationId,
        thirdPartyStationId: thirdPartyStationId
      });
      return `${this.baseQrUrl}?${params.toString()}`;
    },
    // 初始化二维码图片（异步+响应式更新）
    // 初始化二维码图片（最终修复版）
    async initQrImages() {
      if (!this.qrList || this.qrList.length === 0) return

      for (let i = 0; i < this.qrList.length; i++) {
        const item = this.qrList[i]
        if (!item.qrCode || !item.stationId) {
          this.$set(this.qrList, i, { ...item, qrImageUrl: '' })
          continue
        }

        try {
          // 生成正确的URL
          const qrText = this.buildQrUrlParams(item.qrCode, item.stationId, item.thirdPartyStationId)
          console.log('二维码内容：', qrText) // 打开控制台看是否正常

          // 生成二维码
          const qrUrl = await QRCode.toDataURL(qrText, {
            width: 200,
            margin: 1
          })

          // Vue2 强制刷新视图（关键）
          this.$set(this.qrList, i, {
            ...item,
            qrImageUrl: qrUrl
          })
        } catch (err) {
          console.error('生成失败：', err)
          this.$set(this.qrList, i, { ...item, qrImageUrl: '' })
        }
      }
    },
    // 生成二维码图片
    async generateQrImage(text) {
      try {
        const url = await QRCode.toDataURL(text, {
          width: 200,
          margin: 1,
          color: {
            dark: '#333333',
            light: '#ffffff'
          }
        });
        return url;
      } catch (error) {
        console.error('二维码生成失败：', error);
        return '';
      }
    },
    // 选择行变化
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    // 打开新增弹窗
    openAddDialog() {
      this.dialogType = 'add';
      this.resetForm();
      this.dialogVisible = true;
    },
    // 打开编辑弹窗
    async openEditDialog(row) {
      this.dialogType = 'edit';
      // 深拷贝数据
      this.qrForm = JSON.parse(JSON.stringify(row));
      // 确保编辑弹窗有二维码预览
      if (!this.qrForm.qrImageUrl) {
        await this.createQrImage();
      }
      this.dialogVisible = true;
    },
    // 重置表单
    resetForm() {
      if (this.$refs.qrFormRef) {
        this.$refs.qrFormRef.resetFields();
      }
      this.qrForm = {
        id: '',
        qrCode: '',
        stationId: '',
        thirdPartyStationId: '',
        stationName: '',
        qrImageUrl: ''
      };
    },
    // 自动生成二维码编码
    generateQrCode() {
      const timestamp = new Date().getTime().toString().slice(-8);
      const prefix = this.qrForm.stationId || 'SY';
      this.qrForm.qrCode = `${prefix}${timestamp}`;
      this.createQrImage();
    },
    // 创建二维码图片
    async createQrImage() {
      if (this.qrForm.qrCode && this.qrForm.stationId) {
        const qrText = this.buildQrUrlParams(this.qrForm.qrCode, this.qrForm.stationId, this.qrForm.thirdPartyStationId);
        this.qrForm.qrImageUrl = await this.generateQrImage(qrText);
      }
    },
    // 保存表单（需对接实际接口）
    async handleSave() {
      try {
        this.saveLoading = true;
        await this.$refs.qrFormRef.validate();

        if (!this.qrForm.qrImageUrl) {
          await this.createQrImage();
        }

        // 这里需要替换为实际的新增/编辑接口
        if (this.dialogType === 'add') {
          // 示例：调用新增接口
          // const res = await this.$axios.addQrCode(this.qrForm);
          // if (res.code === 200) {
          this.$message.success('新增成功');
          this.dialogVisible = false;
          this.DataList(); // 新增后刷新列表
          // }
        } else {
          // 示例：调用编辑接口
          // const res = await this.$axios.editQrCode(this.qrForm);
          // if (res.code === 200) {
          this.$message.success('编辑成功');
          this.dialogVisible = false;
          this.DataList(); // 编辑后刷新列表
          // }
        }
      } catch (error) {
        this.$message.error('保存失败，请检查表单信息');
        console.error(error);
      } finally {
        this.saveLoading = false;
      }
    },
    // 删除单条数据（需对接实际接口）
    handleDelete(id) {
      this.$confirm(
          '此操作将永久删除该记录, 是否继续?',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(async () => {
        // 示例：调用删除接口
        // const res = await this.$axios.deleteQrCode(id);
        // if (res.code === 200) {
        const index = this.qrList.findIndex(item => item.id === id);
        if (index !== -1) {
          this.qrList.splice(index, 1);
          this.total--;
          this.$message.success('删除成功');
        }
        // }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    // 批量删除
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择要删除的记录');
        return;
      }

      this.$confirm(
          `此操作将永久删除选中的${this.selectedRows.length}条记录, 是否继续?`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(async () => {
        // 示例：调用批量删除接口
        // const ids = this.selectedRows.map(item => item.id);
        // const res = await this.$axios.batchDeleteQrCode(ids);
        // if (res.code === 200) {
        const ids = this.selectedRows.map(item => item.id);
        this.qrList = this.qrList.filter(item => !ids.includes(item.id));
        this.total -= ids.length;
        this.selectedRows = [];
        this.$message.success(`成功删除${ids.length}条记录`);
        // }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    // 预览二维码
    previewQrCode(row) {
      this.previewQrUrl = row.qrImageUrl;
      this.previewStationName = row.stationName;
      this.previewDialogVisible = true;
    },
    // 批量下载二维码
    async handleBatchDownload() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请选择要下载的二维码');
        return;
      }

      this.$message.info(`开始下载 ${this.selectedRows.length} 张二维码`);

      for (let i = 0; i < this.selectedRows.length; i++) {
        const item = this.selectedRows[i];
        if (item.qrImageUrl) {
          await this.downloadSingleQr(item.qrCode, item.qrImageUrl);
          await new Promise(resolve => setTimeout(resolve, 300));
        } else {
          this.$message.warning(`【${item.qrCode}】二维码未生成，跳过下载`);
        }
      }

      this.$message.success('批量下载完成');
    },
    // 下载单张二维码
    downloadSingleQr(fileName, imageUrl) {
      return new Promise((resolve) => {
        if (!imageUrl) {
          this.$message.error('二维码图片不存在，无法下载');
          resolve();
          return;
        }
        const link = document.createElement('a');
        link.href = imageUrl;
        link.download = `${fileName}.png`;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        resolve();
      });
    }
  }
};
</script>

<style scoped>
.qr-code-management {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.search-add-bar {
  display: flex;
  align-items: center;
}

.el-table {
  --el-table-row-hover-bg-color: #f8f9fa;
}

.el-dialog__body {
  padding-bottom: 0 !important;
}

/* 调整操作列按钮间距 */
.el-table .el-button + .el-button {
  margin-left: 5px;
}

/* 分页样式 */
.block {
  text-align: right;
}
</style>